module.exports = __webpack_public_path__ + "static/media/iste.44a3329e.png";